import { useTranslate } from "@refinedev/core";
import { useCallback, useEffect } from "react";
import { usePublishContext } from "./PublishContext";
import dayjs from "dayjs";
import { TimeLimitSelectorCard } from "./TimeLimitSelectorCard";
import styled from "styled-components";
import { radius } from "@libertify/ui";

export const ProjectShareTimeLimitComponent = () => {
  const t = useTranslate();
  const { expirationTime, setExpirationTime } = usePublishContext();

  const handleTimeLimitConfirm = useCallback(
    (_timeType: string, expirationDate?: Date) => {
      if (expirationDate) {
        setExpirationTime(expirationDate);
      }
    },
    [setExpirationTime]
  );

  const handleTimeLimitedChange = useCallback(
    (checked: boolean) => {
      if (!checked) {
        setExpirationTime(null);
      }
      // if time limited is enabled and time limit is not set, set the default time limit
      if (checked && !expirationTime) {
        handleTimeLimitConfirm("24h", dayjs().add(24, "hour").toDate());
      }
    },
    [setExpirationTime, handleTimeLimitConfirm, expirationTime]
  );

  useEffect(() => {
    if (!expirationTime) return;
    const isExpired = new Date() > expirationTime;
    if (isExpired && !!expirationTime) {
      setTimeout(() => {
        setExpirationTime(null);
      }, 0);
    }
  }, [expirationTime, setExpirationTime]);

  return (
    <>
      <TimeLimitedRow>
        <input
          type="checkbox"
          checked={!!expirationTime}
          onChange={(e) => handleTimeLimitedChange(e.target.checked)}
          style={{
            width: 16,
            height: 16,
            accentColor: "#14b8a6",
            cursor: "pointer",
            flexShrink: 0,
          }}
        />
        <TimeLimitedLabel>
          <div className="title">
            {t("media.components.ProjectPublish.timeLimitTitle")}
          </div>
          <div className="desc">
            {t("media.components.ProjectPublish.timeLimitDescription")}
          </div>
        </TimeLimitedLabel>
      </TimeLimitedRow>
      {!!expirationTime && (
        <TimeLimitSelectorCard
          visible={false}
          timeLimit={expirationTime}
          onConfirm={handleTimeLimitConfirm}
          popup={false}
        />
      )}
    </>
  );
};

const TimeLimitedRow = styled.label`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 14px;
  border: 1.5px solid #e5e7eb;
  border-radius: ${radius.box}px;
  cursor: pointer;
  margin-bottom: 8px;
  transition: border-color 0.15s;

  &:has(input:checked) {
    border-color: #14b8a6;
    background: #f0fdfb;
  }
`;

const TimeLimitedLabel = styled.div`
  flex: 1;
  font-family: "Inter Variable", "Inter", sans-serif;

  .title {
    font-size: 13px;
    font-weight: 600;
    color: #111827;
  }

  .desc {
    font-size: 12px;
    color: #6b7280;
    margin-top: 2px;
  }
`;
